import {
  AutocompleteInputComponent,
  AutocompleteItem,
} from '@delmonicos/shared-design-system-react/src/components//autocomplete-input/autocomplete-input.component';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useChargePointContext } from '@app/feature/charge-point/charge-point.context';

interface ByChannelFilterComponentProps {
  channelId?: string;
  handleChangeChannelId: (channelId?: string) => void;
}

export const ByChannelFilterComponent = ({
  channelId,
  handleChangeChannelId,
}: ByChannelFilterComponentProps): React.JSX.Element => {
  const { t } = useTranslation();
  const [search, setSearch] = useState<string>('');

  const { channels } = useChargePointContext();

  const channelsId: AutocompleteItem[] = useMemo(
    () => channels.map((c) => ({ label: c.id, key: c.id })),
    [channels],
  );

  return (
    <Stack gap={GapEnum.M} direction="column">
      <IconText
        iconName="electric-terminal"
        text={t('$.charge-point-details.maintenance.filter.channel.title')}
      />

      <AutocompleteInputComponent
        label={t('$.charge-point-details.maintenance.filter.channel.id')}
        placeholder={t('$.charge-point-details.maintenance.filter.channel.id')}
        emptyResultText={t(
          '$.charge-point-details.maintenance.filter.channel.no-channel',
        )}
        value={search}
        selectedItem={channelId ? { label: channelId, key: channelId } : null}
        items={channelsId}
        onChange={setSearch}
        onSearch={setSearch}
        onSelect={(item) => handleChangeChannelId(item?.key)}
      />
    </Stack>
  );
};
